import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { AuthService } from '../../core/auth.service';
import { environment } from '../../../environments/environment';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SaveReportAsPdfService {
  private urlReportRetrieve =
    environment.baseUrl + environment.api + 'reports/retrieve?fileTokens=';

  constructor(private http: HttpClient, private authService: AuthService) {}

  saveAsPDF(fileTokens) {
    return this.http
      .get(
        this.urlReportRetrieve +
          fileTokens +
          '&type=5',
        {
          headers: this.authService.getJwtAuthHeaders(),
          observe: 'response',
          responseType: 'arraybuffer',
        }
      )
      .pipe(
        catchError((error, caught) => {
          return of();
        })
      );
  }
}
